export default __webpack_public_path__ + "static/media/Mark-3-HUD-08.edf9e84f.jpg";